import React from 'react';
import vaseImg from '../assets/vase.jpg';

const CTASection = () => {
  return (
    <section className="section">
      <div className="full-bg" style={{backgroundImage: `url(${vaseImg})`, filter: 'blur(5px) brightness(0.6)'}}></div>
      <div className="container" style={{textAlign: 'center', color: 'white'}}>
        <span className="tagline" style={{color: 'var(--accent)'}}>Suivez l'Aventure</span>
        <h2 style={{fontSize: '4rem'}}>Restez Connectés</h2>
        <p style={{marginBottom: '40px', fontWeight: '300'}}>
          Un premier univers... et ce n'est que le début. Rejoignez-nous sur Instagram.
        </p>
        <a href="https://www.instagram.com/fabria.store/" target="_blank" rel="noopener noreferrer" className="btn" style={{color: 'white', borderColor: 'white'}}>
          @fabria.store
        </a>
      </div>
    </section>
  );
};

export default CTASection;
